import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
import { i18n } from './i18n'

// Importiere Google Fonts
const link = document.createElement('link')
link.rel = 'stylesheet'
link.href = 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700&family=Roboto:wght@300;400;500;700&display=swap'
document.head.appendChild(link)

// TinyMCE wird über CDN geladen, daher benötigen wir hier keine direkten Imports

createApp(App)
  .use(i18n)
  .mount('#app')
